module.exports = __webpack_public_path__ + "static/header-icon-a-fe3da78797d04fd201047f80313dd32f.png";